export const SECTION_ATTRIBUTE_TYPE = {
    OVERALL: 'OVERALL',
    SUB_VALUE: 'SUB_VALUE',
};
// The instance score is written in two stages, so the ordinal result label can lag the section-level
// row by a few seconds. Poll a bounded number of times rather than indefinitely (CX-5493).
export const TCF_MEASURE_MAX_ATTEMPTS = 5;
export const TCF_MEASURE_RETRY_DELAY_MS = 3000;
export const ATTR_NAME_FLUENCY = 'Fluency';
export const ATTR_NAME_PRONUNCIATION = 'Pronunciation';
export const ATTR_NAME_CARNEGIE = 'CarnegieScore';
export const ATTR_NAME_GRAMMAR = 'Grammar';
export const ATTR_NAME_COHESION = 'Cohesion';
export const DEFAULT_EVALUATION_REPORT_OVERALL_MAX_SCORE = 100;
export const FITB_BLOCK_TYPE = 'fillInTheBlank';
